import React from 'react';
import { Redirect, Route } from 'react-router';
import { connect } from 'react-redux';
import OpenMarketCheckYourRatePage from '../CheckYourRatePage/openMarketCheckYourRatePage';
import DirectMailerCheckYourRatePage from '../CheckYourRatePage/directMailerCheckYourRatePage';
import BankMarketCheckYourRatePage from '../CheckYourRatePage/BankMarketCheckYourRatePage/bankMarketCheckYourRatePage';
import SelectOfferPage from '../SelectOfferPage/selectOfferPage';
import FullAppPage from '../FullAppPage/fullAppPage';
import RenderChildren from '../../hoc/renderChildren';
import Notification from '../Notification/notification';
import FeatureToggle from '../FeatureToggle/feature.toggle';
import { getMarketCode } from '../../selectors';
import { MarketCodes } from '../../marketCodes';

const choosePage = (applicationStep, marketCode) => {
  switch(applicationStep) {
  case 'check-your-rate': {
    switch(marketCode) {
    case MarketCodes.OPEN_MARKET:
      return <OpenMarketCheckYourRatePage />;
    case MarketCodes.DIRECT_MAILER:
      return <DirectMailerCheckYourRatePage />;
    default:
      return <Redirect to="/apply" />;
    }
  }
  case 'offer':
    return [
      <FeatureToggle key="toggleOn" featureName="cl_digital_offers">
        <BankMarketCheckYourRatePage />
      </FeatureToggle>,
      <FeatureToggle key="toggleOff" featureName="cl_digital_offers" showWhenFeatureToggleOff={true}>
        <Redirect to="/apply" />
      </FeatureToggle>
    ];
  case 'select-offer':
    return <SelectOfferPage />;
  case 'submit':
    return <FullAppPage />;
  default:
    return <Redirect to="/apply" />;
  }
};

export const LoanApplication = (props) => {
  const { match, marketCode } = props;

  return (
    <RenderChildren>
      <Route path={`${match.url}/:applicationStep`} render={({ match }) => {
        return (
          <div>
            {choosePage(match.params.applicationStep, marketCode)}
            <Notification />
          </div>
        );
      }}/>
      <Route exact path={`${match.url}`} render={() => <Redirect to="/apply" />} />
    </RenderChildren>
  );
};

const mapStateToProps = (state) => ({
  marketCode: getMarketCode(state)
});

export default connect(mapStateToProps)(LoanApplication);
